/*
 * Aviso "elige bien tu referencia" dentro del formulario de Releasit.
 * Solo se carga desde templates/product.gafas-rb-arocky.json y solo si el producto tiene mas de una variante,
 * asi que no afecta a ninguna otra pagina. No toca ningun boton del formulario: unicamente inserta un bloque de
 * texto justo antes de las tarjetas de oferta de cantidad.
 */
(function () {
  'use strict';

  var NOTE_CLASS = 'rbr-nota-referencia';
  var STYLE_ID = 'rbr-nota-referencia-css';
  var pending = false;

  function addStyle() {
    if (document.getElementById(STYLE_ID)) return;
    var css =
      '.' + NOTE_CLASS + '{margin:0 0 14px;padding:10px 12px;border:1px solid #f0c040;border-left:5px solid #f0a800;' +
      'border-radius:8px;background:#fff8e1;color:#4a3600;font-size:14px;line-height:1.4;text-align:left}' +
      '.' + NOTE_CLASS + ' strong{display:block;margin-bottom:2px;font-size:15px;font-weight:700;color:#3a2a00}';
    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.appendChild(document.createTextNode(css));
    (document.head || document.documentElement).appendChild(style);
  }

  function buildNote() {
    var note = document.createElement('div');
    note.className = NOTE_CLASS;
    note.setAttribute('role', 'note');
    var title = document.createElement('strong');
    title.appendChild(document.createTextNode('⚠️ Por favor, elige bien tu referencia'));
    var body = document.createElement('span');
    body.appendChild(document.createTextNode('Revisa el color del lente y de la montura de cada gafa: es la referencia que te enviaremos.'));
    note.appendChild(title);
    note.appendChild(body);
    return note;
  }

  function insertNote() {
    var modal = document.getElementById('_rsi-cod-form-modal');
    if (!modal || modal.querySelector('.' + NOTE_CLASS)) return;
    var anchor = modal.querySelector('#rsi-cod-form-quantity-offers-hook') ||
      modal.querySelector('._rsi-build-block-order-summary');
    if (!anchor || !anchor.parentNode) return;
    anchor.parentNode.insertBefore(buildNote(), anchor);
  }

  // Releasit arma el formulario cuando se abre, asi que se vigila el DOM y se reinserta el aviso si hace falta.
  function schedule() {
    if (pending) return;
    pending = true;
    (window.requestAnimationFrame || window.setTimeout)(function () {
      pending = false;
      insertNote();
    });
  }

  function start() {
    addStyle();
    insertNote();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }

  if (document.body) start();
  else document.addEventListener('DOMContentLoaded', start);
})();
